import { humanCardName, getBaseCard, getCardVariant } from '../utils/cards';
import CardVariantOverlay from '../CardVariantOverlay';
import { GIFT_CARD_DURATION_SECONDS } from '../utils/storage';

export function GiftCardWarningModal({ isOpen, onClose, card, onConfirm, cardImageFolder = 'smallcards' }) {
    if (!isOpen || !card) return null;

    const variant = getCardVariant(card);
    const cardImage = `./assets/${cardImageFolder}/${getBaseCard(card).toLowerCase()}.png`;
    const cardName = humanCardName(card);
    const expirySeconds = GIFT_CARD_DURATION_SECONDS;

    const handleConfirm = () => {
        onConfirm?.();
        onClose?.();
    };

    return (
        <div className={`modal gift-card-warning-modal ${isOpen ? 'open' : 'closed'}`}>
            <div className='modal-overlay' onClick={onClose}></div>
            <div className='modal-content'>
                <h2>Mint Gift Card?</h2>
                <p>Permanently convert this card into a gift?
                </p>
                <p>The receipient should be ready to claim it within {expirySeconds} seconds by using their camera app to scan the created QR code.</p>

                <div className='gift-card-preview'>
                    <div className='grid'>
                        <div className={`card ${variant ?? ''}`}>
                            {variant ? (
                                <CardVariantOverlay
                                    variant={variant}
                                    imageSrc={cardImage}
                                    alt={cardName}
                                    title={cardName}
                                    className='front preview-image'
                                />
                            ) : (
                                <img alt={cardName} className='front preview-image' src={cardImage} />
                            )}
                        </div>
                    </div>
                </div>


                <div className='gift-warning-info'>
                    <p>
                        One copy of this card will be permanently converted into a {expirySeconds} second QR Gift Code. You'll lose it from your collection.
                    </p>
                    <p>
                        <strong>You will not be able to undo this action.</strong>
                    </p>
                </div>

                <div className='gift-warning-actions'>
                    <button onClick={onClose} className='cancel-btn'>Cancel</button>
                    <button onClick={handleConfirm} className='confirm-btn'>Mint Gift Card</button>
                </div>
            </div>
        </div>
    );
}
